import { ButtonArrow } from '../../../Button'
import { useSelectContext } from '../../../Select'
import Text from '../../../Text'
import { CurrencyAmountInput } from '../../CurrencyAmountInput'

import * as styles from './CurrencySelectControlContent.module.css'

import DropdownIcon from '../../../../icons/dropdown.svg'

function CurrencySelectControlContent({
  className = styles.CurrencySelectControlContent,
  ...restProps
}) {
  const { handleToggleOpen, isOpen, value } = useSelectContext()

  return (
    <div className={className}>
      <div className={styles.currency}>
        <Text>{value.label}</Text>
        <ButtonArrow
          iconProps={{
            iconProps: { Icon: DropdownIcon },
          }}
          isOpen={isOpen}
          onClick={handleToggleOpen}
        />
      </div>
      <CurrencyAmountInput {...restProps} />
    </div>
  )
}

export default CurrencySelectControlContent
